import { useUser } from "@auth0/nextjs-auth0/client"
import { useQuery } from "@tanstack/react-query"
import axios from "axios"

export const useUserProfile = () => {
  const { user } = useUser()
  const queryKey = ["userProfile", user?.sub]

  return useQuery({
    queryKey: queryKey,
    queryFn: async () => {
      const res = await axios.get(`/api/profile`)
      return res.data
    },
    enabled: !!user,
  })
}
